<template>
  <div v-if="quarters">
    <div class="flex md:jc-center quarters-items m-b-4">
      <div 
        v-for="quarter in quarters" 
        :key="quarter.id" 
        @click="quarterId = quarter.id"
        class="quarters-item"
        :class="{'active': quarterId == quarter.id}">
        Четверть {{ quarter.name }} 
      </div>
    </div>

    <Quarter 
      :add="add"
      @addItem="addItem"
      @close="close"
      :id="quarterId"
      :itemLink="`${itemLink}`"
      :setLink="setLink"
      :pushLink="pushLink"
    />
  </div>
</template>
<script>
import { cardUpdate, cardContent, cardGetList, pushLang, cardUpdateList } from "@/plugins/functions";
import PaperTable from "@/components/PaperTable2";
import Quarter from "./Quarter";
import { mapState } from "vuex";
export default {
  components: {
    "paper-table": PaperTable,
    "Quarter": Quarter,
  },
  data: () => ({
    discipline: "",
    quarters: null,
    quarterId: null,
    add: false,

    /** APIs */
    removeLink: "",
    cardLink: "item_lessonplan",
    itemLink: "",
    setLink: "",
    pushLink: "",
  }),
  props: ["id"],
  async created() {
    this.getList()
  },
  methods: {
    cardGetList: cardGetList,
    addItem() {
      // this.setLink = `${this.itemLink}/${this.quarterId}/planned_lessons`;
      this.add = true;
    },
    close(){
      this.add = false;
    },
    openObject(item, card, prefix = "") {
      const element = `${prefix}${card}`;

      let link = item.id;

      let query = Object.assign({}, this.$route.query);
      if (query[element] == link) {
        return false;
      }
      if (query[element]) {
        delete query[element];
      }
      query[element] = link;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
    async getList(loading = true, resetPage = false){
      let query = Object.assign({}, this.$route.query);
      this.discipline = query["item_discipline"]
      this.itemLink = `${this.$store.state.secApiUrl}/school/subjects/${this.discipline}/classes/${this.id}/quarters`;
      this.pushLink = `${this.$store.state.secApiUrl}/school/subjects/${this.discipline}/classes/${this.id}/books`
      // this.setLink = `${this.itemLink}/${this.quarterId}/planned_lessons`;
      
      this.loading = true;
      if (loading) {
        this.$loading(true);
      }

      this.quarters = await this.cardGetList(this.itemLink)
      if(this.quarters){
        this.quarterId = this.quarters[0].id
      }
        
    },
  },
  computed: {
    ...mapState(["languages", "courses"]),
  },
};
</script>
<style>
</style>
